module.exports = __webpack_public_path__ + "static/media/whitePlus.45e6afe9.svg";